import React from 'react';
import cx from 'classnames';

import styles from './PopoverBody.module.scss';

export interface PopoverBodyProps {
  children?: React.ReactNode;
  className?: Parameters<typeof cx>[0];
}

export const PopoverBody: React.FC<PopoverBodyProps> = ({
  children,
  className,
}) => <div className={cx(className)}>{children}</div>;

export default PopoverBody;
export { styles };
